
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import { IToken, tokenStore } from "../utils/token-store";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data() {
		return {
			selectedDossier: tokenStore.selectedDossier,
			dossiers: tokenStore.accessTokens,
			preferedStartupDossier: AuthService.preferedStartupDossier
		};
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		selectDossier(name:string) {
			AuthService.selectDossier(name);
			this.$emit("close");
			this.$router.push("/");
		},
		setPreferedStartupDossier(t:IToken){
			if (t.dossierName == this.preferedStartupDossier) {
				AuthService.preferedStartupDossier = "";
				this.preferedStartupDossier = "";
				return;
			}
			AuthService.preferedStartupDossier = t.dossierName;
			this.preferedStartupDossier = AuthService.preferedStartupDossier;
		},
		getPreferedStartupDossierTooltip(t:IToken):TranslateResult{
			if (t.dossierName == this.preferedStartupDossier){
				return this.$ct("unset-default-dossier");
			}
			return this.$ct("set-default-dossier");
		}
	},
	i18nEx: {
		componentPrefix: "components.SelectDossier"
	}
});
